import { useEffect, useState } from 'react';

import { EdgeHighlight } from 'app/modules/wallforming/components/scenes/objects/helpers/EdgeHighlight';
import { FaceHighlight } from 'app/modules/wallforming/components/scenes/objects/helpers/FaceHighlight';
import { POIFilterType } from 'app/modules/wallforming/components/scenes/objects/pois/types/poiFilterType';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

/**
 * Used as a visual highlight for the currently selected POI (Point of Interest) in the main scene.
 */
export const ReferenceMarker = () => {
    const [selectedPoiIndex, setSelectedPoiIndex] = useState<number | undefined>(
        usePlacementStore.getState().poiSelection.current.index
    );
    const [selectedPoiFilterType, setSelectedPoiFilterType] = useState<POIFilterType | undefined>(
        usePlacementStore.getState().poiSelection.current.filterType
    );

    useEffect(() => {
        const subscribedPoiFilterType = usePlacementStore.subscribe(
            (state) => state.poiSelection.current.filterType,
            (newFilterType) => {
                setSelectedPoiFilterType(newFilterType);
            }
        );

        const subscribedPoiIndex = usePlacementStore.subscribe(
            (state) => state.poiSelection.current.index,
            (newIndex) => {
                setSelectedPoiIndex(newIndex);
            }
        );

        return () => {
            subscribedPoiIndex();
            subscribedPoiFilterType();
        };
    }, []);

    if (selectedPoiIndex === undefined) {
        return null;
    }

    if (selectedPoiFilterType === POIFilterType.Wall) {
        return <FaceHighlight selectedPoiIndex={selectedPoiIndex} />;
    }

    if (selectedPoiFilterType === POIFilterType.Corner) {
        return <EdgeHighlight selectedPoiIndex={selectedPoiIndex} />;
    }

    return null;
};
